// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--RdRv0","link":"link--zXaUj","icon":"icon--ulwNZ","small":"small--FoheK","medium":"medium--JNj5w","large":"large--hstPD","fadeSlideUp":"fadeSlideUp--eTyD0"};